import {
  checkPassword,
  PASSWORD_POLICY,
  type PasswordIdentity,
  type PasswordViolation,
} from '../contracts/password-policy.js';

/** As regras da senha como a pessoa lê (A2, U12): o texto e o que quebra cada uma. */
export const REGRAS_DA_SENHA: ReadonlyArray<{
  texto: string;
  quebra: PasswordViolation[];
}> = [
  {
    texto: `Pelo menos ${PASSWORD_POLICY.minLength} caracteres`,
    quebra: ['too_short', 'too_long'],
  },
  { texto: 'Uma letra maiúscula', quebra: ['missing_uppercase'] },
  { texto: 'Uma letra minúscula', quebra: ['missing_lowercase'] },
  { texto: 'Um número', quebra: ['missing_digit'] },
  {
    texto: 'Não pode conter seu usuário ou e-mail',
    quebra: ['contains_identity'],
  },
  { texto: 'Não pode ser uma senha comum', quebra: ['too_common'] },
];

/** Cada regra e se a senha já cumpre (vazia: nenhuma cumprida). */
export function regrasCumpridas(
  senha: string,
  identidade: PasswordIdentity,
): Array<{ texto: string; ok: boolean }> {
  const quebradas = new Set(checkPassword(senha, identidade));
  return REGRAS_DA_SENHA.map((regra) => ({
    texto: regra.texto,
    ok: !!senha && !regra.quebra.some((item) => quebradas.has(item)),
  }));
}

export function senhaAceita(
  senha: string,
  identidade: PasswordIdentity,
): boolean {
  return checkPassword(senha, identidade).length === 0;
}
